export const attrs_input = {
    dense: true,
    outlined: true,
    hideDetails: true,
    persistentPlaceholder: true,
};

export const attrs_switch = {
    inset: true,
    hideDetails: true,
    class: "pa-0 ma-0",
};

export const attrs_table = {
    "disable-sort": true,
    "disable-pagination": true,
    "hide-default-footer": true,
};

export const attrs_input__table = {
    flat: true,
    solo: true,
    class: "rounded-0",
    hideDetails: true,
    persistentPlaceholder: true,
};
